<template>
<div class="clearfix">

  <a-upload
    accept="image/*"
    action="/api/file/upload/putObject"
    listType="picture-card"
    :fileList="fileList"
    :withCredentials="true"
    :beforeUpload="(file) => beforeUpload(file)"
    @change="({ fileList }) => handleUploadChange({ fileList })"
    @preview="handlePreview"
    :showUploadList="{showPreviewIcon: true}">
    <div v-if="fileList.length < max" style="position:relative;">
      <a-icon type="plus"/>
      <div class="ant-upload-text">上传图片</div>
      <p class="upload-tips">{{options.label}}<br/>支持.jpg .png 格式</p>
    </div>
  </a-upload>

  <a-modal width="1000px" :visible="previewVisible" :footer="null" @cancel="handleCancel">
    <img alt="图片" style="width: 100%" :src="previewImage" />
  </a-modal>

</div>

</template>

<script>

import eBase from '@/base/eBase.js';
import _ from 'underscore';

export default {

  props: {
    options: { required: true },
    value: Array,
    max: { required: false, default: 3 },
    disabled: { required: false, default: false },
  },

  data() {
    return {
      previewVisible: false,
      previewImage: '',
      fileList:this.value?this.value:[],
      showUploadList: { showPreviewIcon: true },
    };
  },

  created() {
    eBase.debug('[DynamicSelect.vue][created][enter]');
  },

  mounted() {
    eBase.debug('[DynamicSelect.vue][mounted][enter]');
  },

  watch: {
    options: {
      handler(newValue, oldValue) {
      },
      immediated: false,
    },
    value: {
      handler(newValue, oldValue) {
        this.fileList = newValue;
      },
      immediated: false,
    },
  },

  computed: {
  },

  methods: {

    beforeUpload(file) {
      const isImg = file.type.indexOf('image') > -1;
      if (!isImg) {
        Vue.prototype.$message.error('请选择图片类型');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小必须小于2M');
      }
      return isImg && isLt2M;
    },

    handleUploadChange({ fileList }) {
      this.fileList = fileList;
      this.triggerChange(fileList);
    },

    triggerChange(value) {
      this.$emit('change', value);
    },

    handleCancel() {
      this.previewVisible = false;
    },

    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },

  }, // EOF methods
};
</script>



// WEBPACK FOOTER //
// src/components/select/DynamicUpload.vue